import { FC, ReactNode } from 'react';
import { CircleButton } from './style';

interface ProfileButton {
	children: ReactNode;
	onClick?: () => void;
}

export const ProfileButton: FC<ProfileButton> = ({ children, onClick }) => {
	return <CircleButton onClick={!window.matchMedia("(pointer: coarse)").matches ? onClick : undefined} onTouchStart={onClick}>{children}</CircleButton>;
};
